<div class="flex flex-col h-full items-center justify-center">
    <img class="mb-2" src="/assets/images/vwlogo.svg" alt="logo">
    <vwui-button class="is-primary" (click)="login()">
        Inloggen op PRS
    </vwui-button>
</div>
